import React from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'
import { useAccount } from 'wagmi';


const ConnectWallent = () => {
    const { isConnected } = useAccount();

    return (
        <>
            <section className="getintouch pt-0">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={8} className="mb-4 text-center">
                            <div className="heading my-4">
                                <h1 className="text-white">
                                    It’s time to join the growing community of investors,
                                    innovators, and institutions transforming DeFi with
                                    Unitronix
                                </h1>
                            </div>
                            {/* {!isConnected &&
                                <Button variant="primary" className="text-black">
                                    Connect Wallet
                                </Button>
                            } */}

                        </Col>
                    </Row>
                </Container>
            </section>
        </>

    )
}

export default ConnectWallent